import {AbstractConditionDescriptionComponent} from "../AbstractConditionDescriptionComponent";

export class ConditionItemRate extends AbstractConditionDescriptionComponent {
    static instance = () => AbstractConditionDescriptionComponent.instance(ConditionItemRate, require('./conditionItemRate.html'));
}